export const ACCESS_ROUTES = [
    'configuration/organization',
    'my-works/dashboard',
    '',
    'login',
    'error/404',
    'error/403',
    'configuration/change-password'
];
